import { render, staticRenderFns } from "./OnboardingWizardShell.vue?vue&type=template&id=19818ec0&scoped=true"
import script from "./OnboardingWizardShell.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingWizardShell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OnboardingWizardShell.vue?vue&type=style&index=0&id=19818ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19818ec0",
  null
  
)

export default component.exports